import React, { useEffect, useState } from 'react';
import { Users, DollarSign, BarChart2, TrendingUp, Package } from 'lucide-react';

const Dashboard = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [dashboardData, setDashboardData] = useState({
    totalUsers: 1245,
    revenue: 45678,
    orders: 345,
    growth: 12.5
  });

  // Example of how you would fetch dashboard data from API
  useEffect(() => {
    const fetchDashboardData = async () => {
      setIsLoading(true);
      try {
        // This is commented out since we're using mock data
        // const data = await apiService.request('/dashboard/stats');
        // setDashboardData(data);
        
        // Simulate API delay with mock data
        setTimeout(() => {
          setDashboardData({
            totalUsers: 1245,
            revenue: 45678,
            orders: 345,
            growth: 12.5
          });
          setIsLoading(false);
        }, 500);
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
        setIsLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  const stats = [
    {
      title: 'Total Users',
      value: dashboardData.totalUsers,
      icon: <Users className="w-6 h-6 text-blue-500" />,
      change: `+${dashboardData.growth}%`,
      changeType: 'increase'
    },
    {
      title: 'Total Revenue',
      value: `$${dashboardData.revenue.toLocaleString()}`,
      icon: <DollarSign className="w-6 h-6 text-green-500" />,
      change: `+${dashboardData.growth}%`,
      changeType: 'increase'
    },
    {
      title: 'Total Orders',
      value: dashboardData.orders,
      icon: <Package className="w-6 h-6 text-orange-500" />,
      change: `+${dashboardData.growth}%`,
      changeType: 'increase'
    }
  ];

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-bold text-gray-800">Dashboard Overview</h1>
        <div className="flex items-center space-x-2 text-sm text-gray-500">
          <span>Last updated: Just now</span>
        </div>
      </div>
      
      {isLoading ? (
        <div className="flex justify-center items-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
        </div>
      ) : (
        <>
          {/* Stats Grid */}
          <div className="grid gap-6 mb-8 md:grid-cols-2 xl:grid-cols-3">
            {stats.map((stat, index) => (
              <div key={index} className="flex items-center p-4 bg-white rounded-lg shadow">
                <div className="p-3 mr-4 rounded-full bg-blue-100">
                  {stat.icon}
                </div>
                <div>
                  <p className="text-sm font-medium text-gray-600">{stat.title}</p>
                  <p className="text-2xl font-semibold text-gray-700">{stat.value}</p>
                  <div className={`flex items-center text-sm ${stat.changeType === 'increase' ? 'text-green-600' : 'text-red-600'}`}>
                    {stat.changeType === 'increase' ? (
                      <TrendingUp className="w-4 h-4 mr-1" />
                    ) : (
                      <BarChart2 className="w-4 h-4 mr-1" />
                    )}
                    <span>{stat.change}</span>
                  </div>
                </div>
              </div>
            ))}
          </div>
          
          {/* Charts Grid */}
          <div className="grid gap-6 mb-8 md:grid-cols-2">
            <div className="min-w-0 p-4 bg-white rounded-lg shadow">
              <h4 className="mb-4 font-semibold text-gray-800">Revenue Overview</h4>
              <div className="flex items-center justify-center h-64 text-gray-400">
                <p>Revenue chart will be displayed here</p>
              </div>
            </div>
            <div className="min-w-0 p-4 bg-white rounded-lg shadow">
              <h4 className="mb-4 font-semibold text-gray-800">Recent Orders</h4>
              <div className="flex items-center justify-center h-64 text-gray-400">
                <p>Recent orders will be displayed here</p>
              </div>
            </div>
          </div>
        </>
      )}
      
      <div className="mt-8 bg-white p-6 rounded-lg shadow">
        <div className="flex items-center justify-between mb-4">
          <h4 className="text-lg font-medium">Monthly Performance</h4>
          <div className="p-2 bg-purple-100 rounded-full">
            <BarChart2 size={20} className="text-purple-600" />
          </div>
        </div>
        <div className="h-64 flex items-center justify-center border border-gray-200 rounded-lg">
          <p className="text-gray-500">Chart visualization would go here</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
